"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smartPricingTasksValidationFactory = void 0;
const types_1 = require("../../../../entities/fact/types");
const constants_1 = require("../../../../tasks/constants");
const taskReviewRequired = (taskName, isPropertyUnpublished, taskCompletenessState) => {
    if (isPropertyUnpublished) {
        return (taskCompletenessState[taskName].completion ===
            types_1.TaskCompletionState.REVIEW_REQUIRED);
    }
    else
        return false;
};
const smartPricingTasksValidationFactory = (isPropertyUnpublished, validationState, taskCompletenessState) => {
    const { property, images } = validationState;
    return {
        [constants_1.Tasks.AMENITIES_FEATURES]: taskReviewRequired(constants_1.Tasks.AMENITIES_FEATURES, isPropertyUnpublished, taskCompletenessState)
            ? types_1.TaskCompletionState.REVIEW_REQUIRED
            : property.fields.amenities,
        [constants_1.Tasks.BEDROOMS]: property.fields.beds,
        [constants_1.Tasks.BATHROOMS]: property.fields.bathrooms,
        [constants_1.Tasks.LOCATION]: taskReviewRequired(constants_1.Tasks.LOCATION, isPropertyUnpublished, taskCompletenessState) ? types_1.TaskCompletionState.REVIEW_REQUIRED : property.fields.address1 && property.fields.postcode && property.fields.city,
        [constants_1.Tasks.PHOTOS]: images.valid,
    };
};
exports.smartPricingTasksValidationFactory = smartPricingTasksValidationFactory;
//# sourceMappingURL=smart-pricing-task-validation.js.map